import { CSSProperties, ReactNode } from 'react';

import { classNames } from '@/utils/classnames';

interface Props {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const Panel = ({ className = '', children, style }: Props) => {
  return (
    <section
      className={classNames('bg-special-background-card', 'rounded-2xl', 'relative', className)}
      style={style}
    >
      {children}
    </section>
  );
};

export default Panel;
